import './css/styles.scss';




// on dom ready
// Make sure to call the function -.-'
document.addEventListener('DOMContentLoaded', () => {
	//ShowNhide();
});
